<h2 mat-dialog-title class="txt-center">Meu Pedido</h2>
<mat-dialog-content class="mat-typography">
  <table mat-table [dataSource]="transactions" class="mat-elevation-z3">

    <ng-container matColumnDef="item">
      <th mat-header-cell *matHeaderCellDef> Item </th>
      <td mat-cell *matCellDef="let transaction"> {{transaction.item}} </td>
      <td mat-footer-cell *matFooterCellDef> Total </td>
    </ng-container>
  
    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef> Preço </th>
      <td mat-cell *matCellDef="let transaction"> {{transaction.price | currency: 'BRL'}} </td>
      <td mat-footer-cell *matFooterCellDef> {{getTotalPrice() | currency: 'BRL'}} </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Excluir </th>
      <td mat-cell *matCellDef="let transaction">
        <mat-icon class="color-pink excluir" (click)="removerItem(transaction.num)" mat-dialog-close>remove_circle</mat-icon>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-icon class="color-pink excluir" (click)="removerPedido()" mat-dialog-close>delete</mat-icon>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions class="btn-dialog">
  <button mat-raised-button [mat-dialog-close]="true" (click)="openPedidoForm()">
    <mat-icon class="color-pink dialog-icon"></mat-icon>
    <span>Pedir</span>
  </button>

  <button mat-raised-button mat-dialog-close>
    <mat-icon class="color-pink dialog-icon"></mat-icon>
    <span class="span-icon">Fechar</span>
  </button>
</mat-dialog-actions>